import React from "react";
import { BrowserRouter } from "react-router-dom";

import OpenContextProvider from "../contexts/OpenContext";
import Router from "./Router";
import Callback from "./Callback";

const App = () => {
  if (window.location.pathname === "/callback")
    return (
      <BrowserRouter>
        <Callback />
      </BrowserRouter>
    );

  return (
    <BrowserRouter>
      <OpenContextProvider>
        <Router />
      </OpenContextProvider>
    </BrowserRouter>
  );
};

export default React.memo(App);
